import {
  FormItem,
  SelectInput,
  TextAreaInput,
  TextInput,
  useFormField,
} from '@framework/form';
import { RowElement } from '@framework/ui';
import { yup } from '@framework/validation';
import React, { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { WidgetType } from '../../../Widget';
import { DefaultValueInput } from '../../common/DefaultValueInput';
import { CommonInputWidgetConfigSchema } from '../common/CommonInputConfigComponent';
import { HiddenWidgetType } from './HiddenWidget.type';
import { IHiddenWidget } from './IHiddenWidget';

export const HiddenWidgetConfigSchema: yup.ObjectSchema<IHiddenWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Hidden).required(),
    dataType: yup
      .string()
      .oneOf([Datatype.String, Datatype.Number, Datatype.Boolean])
      .required()
      .default(Datatype.String)
      .label('Tipo di dato'),
    notes: yup.string().notRequired().label('Note'),
  });

export interface IHiddenWidgetConfigComponentProps
  extends IWidgetComponentProps<IHiddenWidget> {}

export function HiddenWidgetConfigComponent(
  props: IHiddenWidgetConfigComponentProps,
) {
  const widgetConfigForm = useWatch() as IHiddenWidget;

  const dataTypeField = useFormField('dataType');

  const fieldDataType = useMemo(() => {
    return HiddenWidgetType.getReference?.([], widgetConfigForm)?.field;
  }, [widgetConfigForm]);

  return (
    <>
      <FormItem name="code" label="Codice">
        <TextInput name="code" />
      </FormItem>
      <RowElement>
        <FormItem name="dataType" label="Tipo di dato">
          <SelectInput
            name="dataType"
            defaultValue={Datatype.String}
            options={[
              {
                label: 'Stringa',
                value: Datatype.String,
              },
              {
                label: 'Numero',
                value: Datatype.Number,
              },
              {
                label: 'Booleano',
                value: Datatype.Boolean,
              },
            ]}
          />
        </FormItem>
        <DefaultValueInput
          allowsReferences={ref => {
            return ref.field.type === dataTypeField.value;
          }}
          forceFieldDataType={fieldDataType}
        />
      </RowElement>
      <FormItem
        name="notes"
        label="Note del configuratore"
        help="Questo campo sarà visibile solo in fase di configurazione."
      >
        <TextAreaInput name={'notes'} rows={3} />
      </FormItem>
    </>
  );
}
